module.exports = "<lk-sidebar></lk-sidebar>\n<router-outlet></router-outlet>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/frame/frame.component.html
// module id = 208
// module chunks = 1